import { apiRequest } from './request.js';

/**
 * Onboarding post-registro. El frontend persiste el avance cada vez que
 * el usuario cambia de intenciones o completa el wizard, así si cierra
 * el navegador a mitad lo retomamos donde lo dejó.
 */
export const onboardingAPI = {
    update: async ({ intents, completed } = {}) => {
        const body = {};
        if (intents !== undefined) body.intents = intents;
        if (completed !== undefined) body.completed = !!completed;
        return apiRequest('/users/me/onboarding/', {
            method: 'PATCH',
            body: JSON.stringify(body),
        });
    },
};
